<template>
    <div class="ml-4 ">
        <!-- heading -->
        <h1 class="text-muted mb-4">
            <vue-fontawesome class="mr-2" size="2" icon="shopping-basket"></vue-fontawesome>
            POS
        </h1>    		
        <content class="">                 
            <!-- ADD SALE -->
            <section>			
				<div class="">
					<div class="d-flex justify-content-between">
						<h3 class="font-weight-bold">
							New Sale
						</h3>                          
						<button v-if="! is_full_screen" class="mr-4 btn btn-outline-success border-0"
							@click="fullscreen()">								
							[ ]
						</button>
						<button v-if="is_full_screen" type="button" class="mr-4 close" aria-label="Close"
							@click="fullscreen()">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body row">
						<!-- search product -->					
						<!-- shopping cart -->
						<section class="col-lg-12">							
							<ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">																		
								<li class="nav-item d-flex" v-for="basket in open_baskets" :key="basket.id">									
										<a class="nav-link" 											
											:class="{ 'active' : active_basket == '001'}"
											data-toggle="pill" 
											:href="`#pills-basket-${basket.id}`"
											role="tab" 											
											:aria-controls="`pills-basket-${basket.id}`"											
											style="font-size: 20px"
											aria-selected="false"
											@click="active_basket = basket.id">												
											<span v-if="basket.customer == 'Walk in customer'" class="p-2">
												Walk in customer												
											</span>
											<span v-else class="p-2">
												<span v-if="basket.customer.name == 'Walk in customer'" class="p-2">
													Walk in customer {{basket_index(basket.id) + 1}}
												</span>
												<span v-else class="p-2">
													{{basket.customer.name}}
												</span>	
											</span>																		
											
										</a>
										<!-- <i style="color: red; font-weight: bold; cursor: pointer;"
											@click="removeBasket(basket.id)"
											class="p-2">
											&times;
										</i>																	 -->
								</li>							
								<!-- <li class="nav-item">
									<a class="nav-link text-success" 
										id="create-new-basket-button"									
										style="font-size: 20px; cursor: pointer;"
										@click="newBasket()">
										+ <vue-fontawesome class="mr-2" icon="shopping-basket"></vue-fontawesome> Add cart
									</a>
								</li> -->
							</ul>	
							<!-- customer basket tabs content					 -->
							<div class="tab-content" id="pills-tabContent">
								<div>
									<div class="tab-pane fade" 
										:class="{ 'show active' : active_basket == '001'}"
										v-for="basket in open_baskets" :key="basket.id"
										:id="`pills-basket-${basket.id}`"
										role="tabpanel" >									
										<div class="p-3 d-flex justify-content-between">	
											<div v-if="basket.customer == 'Walk in customer'" class="p-2">
												<h6>Walk in customer {{basket_index(basket.id) + 1}}</h6>
											</div>
											<div v-else class="p-2">
													<span v-if="basket.customer.name == 'Walk in customer'" class="p-2">
														Walk in customer {{basket_index(basket.id) + 1}}
													</span>
													<span v-else class="p-2">
														{{basket.customer.name}}
													</span>	
											</div>
											<!-- Change customer -->
											<div class="dropdown dropright">
												<a class="btn btn-outline-success border-0" 
													href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
													<vue-fontawesome class="mr-2" icon="pencil"></vue-fontawesome>
												</a> 
												<div class="dropdown-menu dropright border-0" aria-labelledby="dropdownMenuLink">
													<div class="shadow shadow-lg border-0 rounded">
														<searchCustomer v-model="basket.customer"/>													
													</div>
												</div>
											</div>
											<!-- Change date -->
											<span class="p-2">
												{{date | dateformat}}
											</span>										
											<div class="dropdown dropright">
												<a class="btn btn-outline-success border-0" 
													href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">												
													<vue-fontawesome class="mr-2" icon="pencil"></vue-fontawesome>
												</a> 
												<div class="dropdown-menu dropright border-0" aria-labelledby="dropdownMenuLink">
													<div class="p-3 shadow shadow-lg border-0 rounded">
														<div class="form-group d-flex justify-content-between">
															<label class="p-2">Date</label>
															<input type="date" name="bday" max="3000-12-31" 
															min="1000-01-01" class="col-8 form-control" v-model="date"> 
														</div> 											
													</div>
												</div>
											</div>
											<div class="dropdown">
												<button class="btn btn-success" type="button" @click="openProducts()">
													+ Add product
												</button>											
											</div>
										</div>
										<div class="p-2 rounded shadow-sm" id="selectedProducts">
											<table class="table table-borderless">
												<thead>
													<tr>																											
													<th scope="col">product</th>
													<th scope="col">quantity</th>
													<th scope="col">price</th>
													<th scope="col">subtotal</th>
													<th></th>
													</tr>
												</thead>																		
												<tbody v-if="basket.products.length">
													<tr v-for="(product,index) in basket.products" :key="index"												
														:id="`basket-item-${product.id}`">																																
														<td v-if="product.product">
															<div>
																{{product.product.name}}<br/>
																<small v-if="product.selection.variant">
																	{{product.selection.variant.variant}} - {{product.selection.variant.value}}
																</small>
															</div>															
														</td>
														<td v-if="product.product">
															<div>
																<input type="number" 
																class="form-control" 
																style="max-width:70px"
																v-model="product.selection.quantity">
															</div>															
														</td>
														<td v-if="product.product">
															<div>
																{{product.selection.price | intcomma}}
															</div>															
														</td>
														<td v-if="product.product">
															<div>
																{{(product.selection.price * product.selection.quantity) | intcomma}}
															</div>
														</td>
														<td v-if="product.product">
															<div>
																<i class="delete-button p-2 cursor-pointer"
																	@click="removeProductFromBasket(index)">
																	&times;
																</i>	
															</div>														
														</td>
													</tr>																										
												</tbody>
												<div v-else class="mt-5 text-muted d-flex justify-content-center">
													No products added to this cart <br>
													select products from the product list to add.
												</div>

											</table>	
										</div>
										<!-- totals -->
										<div class="p-4 d-flex justify-content-end">										
											<span class="mr-4 mt-2 font-weight-bold">
												{{basket_stats(basket.id).number_of_items}} items |
											</span>
											<span class="mr-4 mt-2 font-weight-bold">
												totals: Ksh {{basket_stats(basket.id).total |intcomma}}
											</span>
											<button class="btn btn-success" 
												data-toggle="modal" data-target="#processPaymentModal"
												@click = "openProcessPaymentModal(basket_stats(basket.id))">
												Process Payment
											</button>
										</div>
									</div>
								</div>																														
							</div>
						</section>
					</div>					
				</div>
				<!-- Button trigger receipt modal -->
				<button type="button" id="receipt-modal-button" class="d-none btn" data-toggle="modal" data-target="#ReceiptModal">
					Launch receipt modal
				</button>
			</section>	
			<!-- search products -->
			<section id="search_products_div" class="d-none rounded shadow shadow-sm rounded bg-white" 
				style="width:400px; right: 0;position: absolute; top: 0; height: 100vh;">
				<div class="">
					<searchProducts context="sales" v-on:productPicked="productPicked"/>
				</div>
			</section>	                
			<!-- modals -->
			<section>
				<!--process payment modal-->
				<div class="modal fade" id="processPaymentModal" tabindex="-1" role="dialog" aria-labelledby="processPaymentModal" aria-hidden="true">
						<div class="modal-dialog modal-dialog-centered" role="document">
							<div class="modal-content">
								<div class="modal-header border-0" v-if="receipt_data">
									<h5 class="modal-title" v-if="! sale_successful">
										Process Payment ( {{receipt_data.number_of_items}} items worth Ksh {{receipt_data.total | intcomma}} )
									</h5>
									<button type="button" id="closeAddSaleModal" class="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">&times;</span>
									</button>
								</div> 
								<form id="processPaymentForm">
									<div class="modal-body d-flex flex-column justify-content-center" style="min-height: 50vh; overflow-y: scroll"
										v-if="sale_successful">
										<div class="d-flex justify-content-center">
											<h3><vue-fontawesome class="mr-2" icon="check"></vue-fontawesome></h3>
											<h3 class="text-success text-center">
												Sale												
												Successful												
											</h3>
										</div>
									</div>
									<div class="modal-body"
										v-if="! sale_successful">
										
										<ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
											<li class="nav-item" role="presentation">
												<a class="nav-link active" id="pills-cash-tab" data-toggle="pill" href="#pills-cash" role="tab" aria-controls="pills-cash" aria-selected="true">
													<vue-fontawesome class="mr-2" icon="money"></vue-fontawesome>Cash
												</a>
											</li>
											<li class="nav-item" role="presentation">
												<a class="nav-link" id="pills-mpesa-tab" data-toggle="pill" href="#pills-mpesa" role="tab" aria-controls="pills-mpesa" aria-selected="false">
													<vue-fontawesome class="mr-2" icon="mobile"></vue-fontawesome>M-Pesa
												</a>
											</li>
											<li class="nav-item" role="presentation">
												<a class="nav-link" id="pills-credit-tab" data-toggle="pill" href="#pills-credit" role="tab" aria-controls="pills-credit" aria-selected="false">
													<vue-fontawesome class="mr-2" icon="credit-card"></vue-fontawesome>Credit
												</a>
											</li>
										</ul>
										<div class="p-5 tab-content" id="pills-tabContent">
											<div class="tab-pane fade show active" id="pills-cash" role="tabpanel" aria-labelledby="pills-cash-tab">
												<label>Cash</label>												                               
												<div class="p-3 d-flex justify-content-between">
													<label class="font-weight-bold">amount</label>
													<input type="number" class="col-8 form-control" v-model="payments.cash_amount">
												</div>  
												<div class="p-3 d-flex justify-content-end">
													deficit
													<span class="ml-3 text-danger">{{deficit | intcomma}}</span>
												</div>
											</div>
											<div class="tab-pane fade" id="pills-mpesa" role="tabpanel" aria-labelledby="pills-mpesa-tab">
												<label>M-pesa</label>											
												<div class="p-3 d-flex justify-content-between">
													<label class="font-weight-bold">amount</label>
													<input type="number" class="col-8 form-control" v-model="payments.mpesa_amount">
												</div> 
												<div class="p-3 d-flex justify-content-between">
													<label class="font-weight-bold">transaction ID</label>
													<input type="text" class="col-8 form-control" v-model="payments.transaction_id">
												</div> 
											</div>
											<div class="tab-pane fade" id="pills-credit" role="tabpanel" aria-labelledby="pills-credit-tab">
												<label >Credit</label>
												<div class="p-3 d-flex justify-content-between">
													<label class="font-weight-bold">amount</label>
													<input type="number" class="col-8 form-control" v-model="payments.credit_amount">
												</div> 
											</div>
										</div>									   																																									                                                                                                                                                     
									</div>
									<div class="modal-footer border-0" v-if="! sale_successful">                            
										<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
										<button type="submit" class="btn btn-success"
											@click="makeSale()">                                                        
											Complete
											<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="adding"></span>											
										</button>
									</div> 
								</form>                                                                                                                                                                                                                                     
							</div>
						</div>
				</div>
				<!-- receipt modal. -->
				<div class="modal fade" id="ReceiptModal" tabindex="-1" role="dialog" aria-labelledby="ReceiptModal" aria-hidden="true">
					<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
					<div class="modal-content" id="ReceiptModalContent" v-if="receipt_modal_data">
						<div class="modal-header border-0">
						<h5 class="modal-title font-weight-bold" >Receipt No. {{receipt_modal_data.id}}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
						</div>
						<div class="modal-body">								
							<div class="d-flex justify-content-between">
								<!-- deatils -->
								<section class="p-3" style="border-right: solid 1px darkgray ; min-width: 200px;">										
									<span class="d-flex flex-column">
										<label class="font-weight-bold">Date:</label>										
										<p class="ml-2">{{receipt_modal_data.date | dateformat}}</p>
									</span>
									<span class="d-flex flex-column">
										<label class="font-weight-bold">Order Number:</label>
										<span class="ml-2">{{receipt_modal_data.orderNumber}}</span>
									</span>
									<span class="d-flex flex-column">
										<label class="font-weight-bold">Customer:</label>
										<span class="ml-2">{{receipt_modal_data.customerId}}</span>
									</span>
									<span class="d-flex flex-column">
										<label class="font-weight-bold">Via</label>
										<span class="ml-2">{{receipt_modal_data.via}}</span>
									</span>																			
								</section>
								<!-- Items sold and payments -->
								<section class="p-3 d-flex justify-content-center flex-wrap" style="height:50vh; overflow-y:scroll">										
									<!-- items sold -->
									<div class="table-responsive">
										<h3 class="text-muted">Items sold</h3>
										<table class="table table-borderless">													
											<thead>
												<tr>												
												<th scope="col">Product</th>
												<th scope="col">Qty</th>												
												<th scope="col">Price</th>
												<th scope="col">subtotal</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(product,index) in receipt_modal_data.products" :key="index">												
													<td>{{product.name}}</td>												
													<td>{{product.qty}}</td>
													<td>{{product.total | intcomma}}</td>
													<td>{{(product.total * product.qty) | intcomma}}</td>
												</tr>												
												<tr>
													<td class="font-weight-bold">TOTAL</td>												
													<td></td>
													<td></td>
													<td class="font-weight-bold">{{totalPrice(receipt_modal_data.products) | intcomma }}</td>
												</tr>
											</tbody>
										</table>
									</div>										
									<!-- payments-->
									<div class="table-responsive">
											<h3 class="text-muted">Payments</h3>
											<table class="table table-borderless">													
												<thead>
													<tr>																										
													<th scope="col">Type</th>
													<th scope="col">Transaction Id</th>
													<th scope="col">Amount</th>																										
													</tr>
												</thead>
												<tbody>
													<tr v-for="(payment,index) in receipt_modal_data.payments" :key="index">																											
														<td>{{payment.type}}</td>
														<td>{{payment.transaction_id}}</td>
														<td>{{payment.amount | intcomma}}</td>															
													</tr>												
												</tbody>
											</table>
										</div>										
								</section>

								<div></div>
							</div>
						</div>
						<div class="p-4 mt-0 border-0">
								<span class="d-flex justify-content-between">
									<label class="font-weight-bold">Items:</label>
									<span class="ml-2">{{totalItems(receipt_modal_data.products) | intcomma}}</span>
								</span>	
								<span class="d-flex justify-content-between">
									<label class="font-weight-bold">Total cost:</label>
									<span class="ml-2">{{totalPrice(receipt_modal_data.products) | intcomma}}</span>
								</span>
								<span class="d-flex justify-content-between">
									<label class="font-weight-bold">Total payed:</label>											
									<span class="ml-2">{{totalPayment(receipt_modal_data.payments) | intcomma}}</span>
								</span>																						
						</div>
						<div class="modal-footer">							
							<button type="button" class="btn btn-outline-success" data-dismiss="modal">Continue selling</button>
							<button type="button" class="btn btn-success" data-dismiss="modal" @click="printReceipt()">Print receipt</button>
						</div>
					</div>
					</div>
				</div>
					<!-- printable receipt modal -->
					<div class="modal fade" id="printModal" tabindex="-1" role="dialog" aria-labelledby="printModalLabel" aria-hidden="true">
						<div class="modal-dialog" role="document">
						<div class="modal-content">
							<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">printable receipt</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
							</div>
							<div class="modal-body">
								<!-- ticket -->
								<div id="receipt-el" v-if="receipt_modal_data">
									<div class="ticket">
										<div class="d-flex justify-content-center">
											<img style="width: 40px; height: auto;" src="@/assets/logo.png" alt="">
										</div>
										<p class="centered">VIDDUKA
											<br>DATE: {{receipt_modal_data.date | dateformat}}
											<br>ORDER: {{receipt_modal_data.orderNumber}}
										</p>
										<table class="receipt">										
											<thead class="receipt">
												<tr class="receipt">
													<th class="receipt">Name</th>
													<th class="receipt quantity">Q.</th>
													<th class="receipt description">price</th>
													<th class="receipt price">Total</th>
												</tr>
											</thead>
											<tbody class="receipt">
												<tr class="receipt" v-for="(product,index) in receipt_modal_data.products" :key="index">
													<td class="receipt">{{product.name}}</td>
													<td class="receipt quantity">{{product.qty}}</td>											
													<td class="receipt price">{{product.total | intcomma}}</td>
													<td class="receipt">{{(product.total * product.qty) | intcomma}}</td>
												</tr>
												<tr>
													<td class="font-weight-bold">TOTAL</td>												
													<td></td>
													<td></td>
													<td class="font-weight-bold">{{totalPrice(receipt_modal_data.products) | intcomma }}</td>
												</tr>
											</tbody>
										</table>
										<hr>
										<div class="centered">
											<p>PAYMENTS</p>
											<table class="receipt">													
												<thead class="receipt">
													<tr class="receipt">																										
														<th scope="col">Type</th>
														<th scope="col">Transaction Id</th>
														<th scope="col">Amount</th>																										
														</tr>
												</thead>
												<tbody class="receipt">
													<tr v-for="(payment,index) in receipt_modal_data.payments" :key="index">																											
														<td>{{payment.type}}</td>
														<td>{{payment.transaction_id}}</td>
														<td>{{payment.amount | intcomma}}</td>															
													</tr>												
												</tbody>
											</table>
										</div>
										<p class="centered">Thanks for your purchase!
											<br>vidduka.com
										</p>
									</div>
								</div> 
							</div>
							<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
							<button type="button" class="btn btn-primary">Save changes</button>
							</div>
						</div>
						</div>
					</div>
			</section>
        </content>  	     
    </div>
</template>

<script>
// @ is an alias to /src
import searchProducts from '@/components/searchProducts.vue'
import searchCustomer from '@/components/searchCustomer.vue'
export default {
name: 'pos',
components: {
    searchProducts,
    searchCustomer
},
data(){
    return{	
		//toggle full screen
		customers:null,	
		is_full_screen:false,
		//        
		active_basket: null,		
        open_baskets:[
            {
                "id": '001',
                "customer": "Walk in customer",
                "products":[                   
                ],				
            }
		],
		receipt_data:null,
		payments: {},
		deficit: 0,
		sale_successful: false,
		adding:false,
		date: this.$moment(),
		//showing receipt.
		receipt_modal_data:null
    }
},
mounted(){
	document.getElementById('processPaymentForm').submit((e)=>{
		e.preventDefault()
	})
	this.getCustomers()
	this.active_basket = '001'
},
computed:{     
	account_switched(){
		return this.$store.state.account_switch_count
	}
},
watch:{
	account_switched: function(){
		this.getCustomers()
	}, 
},
methods:{
	openProducts: function(){
		var div = document.getElementById('search_products_div')
		div.classList.remove('d-none')
	},
	closeProducts: function(){
		var div = document.getElementById('search_products_div')
		div.classList.add('d-none')
	},
	//fetch list of customers
	getCustomers: function(){                        
		this.$http({
			method:'get',				
			url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/customers/`,
			headers:{
				Authorization: JSON.parse(localStorage.getItem('auth_token'))
			},            
		}).then((response)=>{
			this.customers = response.data
		}).catch((err)=>{
			this.$emit('alert',err)
		})
	},	
	//expand to full screen.
	fullscreen: function(){
		if (! this.is_full_screen){
			//scroll to bottom
			window.scrollTo(0,document.body.scrollHeight);
			this.$emit("closeNav")
			this.is_full_screen = true
		}		
		else{
			//sroll to top
			document.body.scrollTop = 0 // For Safari
			document.documentElement.scrollTop = 0
			this.$emit("openNav")
			this.is_full_screen = false
		}
	},	
	//create a new basket.
    newBasket: function(){
        this.open_baskets.push(
            {
                "id": Math.floor(Date.now() / 1000), 
                "customer": "Walk in customer",
                "products": [
                    {
                        "id": Math.floor(Date.now() / 1000),
                        "product": null,
                        "quantity": 1
                    }
                ]
            },			
        )
	},
	//remove a basket from the list of baskets
    removeBasket: function(id){
        var index = this.open_baskets.findIndex((basket) => basket.id === id)
        this.open_baskets.splice(index,1)
	},	
	//get basket index.
    basket_index: function(id){
        return this.open_baskets.findIndex((basket) => basket.id === id)
	},
	//when user picks a product.
	productPicked:function(selected_product){
		this.closeProducts()			
		if(! this.active_basket){
			alert("No cart selected, select one to add products")
		}
        if(selected_product != null){
			//selects active basket.
			var index = this.basket_index(this.active_basket)		
			var products = this.open_baskets[index].products			         
			//check if product exists			
			products.filter((p)=>{		
                if (p.product == null){
                    //if empty then remove from list                    
                    products.splice(p,1)
                }								
            })
			//generate id for product
            var id = Math.floor(Date.now())
			//add product to the top of the list
            products.push({
                "id": id,
                "product":selected_product.product,                
				"selection": selected_product.selection
            })			
            setTimeout(()=>{
				var el = document.getElementById("selectedProducts")
				el.scrollTop = el.scrollHeight
                var tr = document.getElementById(`basket-item-${id}`)
				tr.classList.add('active')				
            },100)
        }
        //reset		
        selected_product = null
	},
	removeProductFromBasket:function(index){
		//selects active basket.
		var basket_index = this.basket_index(this.active_basket)
		var products = this.open_baskets[basket_index].products					
		
		products.splice(index,1)			
            
    },
    basket_stats: function(id){
        var total = 0 
        var number_of_items = 0		
        var index = this.basket_index(id)
        //total
        var products = this.open_baskets[index].products
        for (var i in products){											
            var product = products[i]
            if(product.product != null){
                total += parseInt(product.selection.price) * product.selection.quantity				
                number_of_items += parseInt(product.selection.quantity)
            }						
        }
        return {"total":total,"number_of_items":number_of_items}
	},

	//PAYMENTS
	//process payments
	openProcessPaymentModal:function(stats){
		this.receipt_data = stats
	},
	//get the ID of a customer
	getCustomerID(name){
		var customer = this.customers.filter((c)=>{
			return c.name.toUpperCase() === name.toUpperCase()
		})
		if (customer.length == 0){
			alert("'walk in customer not found. Add a 'walk in customer' to your customer list")
		}
		else{
			return customer[0].id
		}		
	},
	//organize sale data for posting to server
	organizeSaleData(){
		var data = {}
		var basket_index = this.basket_index(this.active_basket)
		var basket = this.open_baskets[basket_index]		
				
		if (basket){
			//customer.
			if(basket.customer === "Walk in customer"){
				data.customerId = this.getCustomerID(basket.customer)
			}
			else{
				data.customerId = basket.customer.id
			}

			//products.
			var products = []
			for (var p of basket.products){								
				if (p.selection.variant){
					products.push({
						"name":p.product.name,
						"product_id" : p.product.id,
						"qty" : p.selection.quantity,
						"total" : p.selection.price,
						"variant":p.selection.variant.value
					})
				}	
				else{
					products.push({
						"name":p.product.name,
						"product_id" : p.product.id,
						"qty" : p.selection.quantity,
						"total" : p.selection.price,						
					})
				}		
			}
			data.products = products						

			//payments.
			var payments = []
			var payment_total = 0
			if (this.payments.cash_amount){
				payments.push({	
					"id": this.$randID(),
					"type": "c",
					"amount": this.payments.cash_amount,
					"transaction_id": "N/A"
				})
				payment_total += this.payments.cash_amount
			}
			if (this.payments.mpesa_amount){
				payments.push({			
					"id": this.$randID(),	
					"type": "m",
					"amount": this.payments.mpesa_amount,
					"transaction_id": this.payments.transaction_id || "not given"
				})
				payment_total += this.payments.mpesa_amount
			}
			if (this.payments.credit_amount){
				payments.push({			
					"id": this.$randID(),	
					"type": "cr",
					"transaction_id": "N/A",
					"amount": this.payments.credit_amount,
				})
				payment_total += this.payments.credit_amount
			}

			// check if payments match totals
			if (payment_total < this.receipt_data.total && basket.customer !== "Walk in customer"){
				this.deficit = this.receipt_data.total - payment_total
				var confirmed = confirm(`Total payment is less than expected payment, do you wish to add ${this.deficit} as debt for this customer`)
				if (confirmed){					
					payments.push({			
						"id": this.$randID(),	
						"type": "cr",
						"transaction_id": "N/A",
						"amount": this.deficit,
					})					
				}
				else{
					alert('Payment could not be completed.')
					return null
				}
			}
			// if no customer was selected
			if (basket.customer === "Walk in customer" && payment_total < this.receipt_data.total){
				alert('We could not make a credit payment for a non customer, please select a customer to complete payment')
				return null
			}
			data.payments = payments			
		}		

		return data
		

	},
	//make sale
	makeSale: function(){				
		var organised_data = this.organizeSaleData()
		if (organised_data){
			this.adding = true
			this.$http({
				method: 'post',
				url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/sale/`,
				headers:{
					Authorization: JSON.parse(localStorage.getItem('auth_token'))
				},
				data:{
					customerSale: {
						id: this.$randID(),
						date: this.$moment().format('YYYY-MM-DDTHH:mm:ssZZ'),
						customerId: organised_data.customerId,
						orderNumber: "N/A",
						via: "web",
						payments: organised_data.payments,
						products: organised_data.products,
					},
					loc_id: JSON.parse(localStorage.getItem('logged_in_user_location_id'))
				}
			}).then((response)=>{
				this.adding = false
				this.payments = {}
				this.sale_successful =true
				this.$store.commit('new_sale')
				setTimeout(()=>{
					document.getElementById('closeAddSaleModal').click()
					this.sale_successful = false					
				},3000)
				setTimeout(()=>{
					var response_data = response.data
					response_data.products = organised_data.products
					this.openReceipt(response_data)
				},1000)
				this.open_baskets[0].products = []
				this.open_baskets[0].customer = 'Walk in customer'
			}).catch((err)=>{
				this.adding = false				
				alert(err)
			})
		}
	},
	totalItems: function(products){
		var total = 0
		for (var i in products){				
			total += parseInt(products[i].qty)
		}
		return total
	},
	totalPayment: function(payments){
		var total = 0.00
		for (var i in payments){
			total += parseFloat(payments[i].amount)
		}
		return total
	},
	totalPrice: function(products){	
		var total = 0.00
		for (var product of products){
			total += (product.total * product.qty)
		}
		return total
	},
	openReceipt: function(sale){
		//create modal data
		this.receipt_modal_data = sale
		//open modal
		var button = document.getElementById('receipt-modal-button')
		button.click()
	},
	//generate receipt.
	generateReceipt: function(){
		var element = document.getElementById('ReceiptModalContent')
		element.print()
	},
	//print_receipt.
	printReceipt: function(){
		var receipt = document.getElementById('receipt-el').innerHTML
		var a = window.open('', '', 'height=500, width=500');
		a.document.write('<html>');
		a.document.write('<body>');
		a.document.write(receipt);
		a.document.write('</body></html>');
		a.document.close();
		a.print();
	}
}
}
</script>
<style>
    .delete-button{		
        color: red;
        font-weight: bold;
        font-size: 25px;
        border-radius: 5px;
        transition: all 0.1ms;
    }
    .delete-button:hover{		
        background-color: white;		
    }
    tr td div {
        max-height: 0;
        padding: 0 10px;
        box-sizing: border-box;
        overflow: hidden;
        transition: max-height 0.3s, padding 0.3s;
    }
    tr.active td div {
        max-height: 100px;
        padding: 10px 10px;
        transition: max-height 0.6s, padding 0.6s;
    }
	.receipt {
    font-size: 12px;
    font-family: 'Times New Roman';
}

	td.receipt,
	th.receipt,
	tr.receipt,
	table.receipt {
		border-top: 1px solid black;
		border-collapse: collapse;
	}

	td.description,
	th.description {
		width: 75px;
		max-width: 75px;
	}

	td.quantity,
	th.quantity {
		width: 40px;
		max-width: 40px;
		word-break: break-all;
	}

	td.price,
	th.price {
		width: 40px;
		max-width: 40px;
		word-break: break-all;
	}

	.centered {
		text-align: center;
		align-content: center;
	}

	.ticket {
		width: 155px;
		max-width: 155px;
	}

	img {
		max-width: inherit;
		width: inherit;
	}

	@media print {
		.hidden-print,
		.hidden-print * {
			display: none !important;
		}
	}
</style>